<template>
    <v-menu
        offset-y
        nudge-top="42"
        nudge-left="30"
        min-width="240"
        :close-on-content-click="false"
        left
    >
        <template v-slot:activator="{ on, attrs }" >
            <div>
                <a
                    v-bind="attrs"
                    v-on="on"
                >
                    <div style="padding-top: 6px;">
                        <v-icon color="primary" size="22" style="width: 18px;">mdi-filter</v-icon>
                    </div>
                </a>
            </div>
        </template>

        <div class="white pa-2 pb-3">
            <crm-entry-filter-menu-entry
                v-model = "filter.deleted"
                icon    = "far fa-trash-alt"
                label   = "Gelöschte Einträge"
                color   = "red"
                @input  = "onFilter"
            />

            <crm-entry-filter-menu-entry
                v-model = "filter.phonecalls"
                icon    = "fas fa-phone"
                label   = "Telefonate"
                @input  = "onFilter"
            />

            <crm-entry-filter-menu-entry
                v-model = "filter.comments"
                icon    = "far fa-comment"
                label   = "Gespräch"
                @input  = "onFilter"
            />

            <crm-entry-filter-menu-entry
                v-model = "filter.reminder"
                icon    = "far fa-bell"
                label   = "Wiedervorlage"
                @input  = "onFilter"
            />

            <crm-entry-filter-menu-entry
                v-model = "filter.mails"
                icon    = "far fa-envelope"
                label   = "Versendete Mails"
                @input  = "onFilter"
            />

            <crm-entry-filter-menu-entry
                v-model = "filter.documents"
                icon    = "far fa-file"
                label   = "Dokumente"
                @input  = "onFilter"
            />

            <crm-entry-filter-menu-entry
                v-model = "filter.clipboard"
                icon    = "far fa-clipboard"
                label   = "Clipboard"
                @input  = "onFilter"
            />
        </div>
    </v-menu>
</template>

<script>

import CrmEntryFilterMenuEntry from "@/modules/crm/components/main/CrmEntryFilterMenuEntry.vue";

export default {
    name: "CrmEntryFilterMenu",
    components: {
        CrmEntryFilterMenuEntry
    },

    computed: {
        preferences() {
            return this.$store.getters.preferences;
        },

        filter () {
            return this.$store.getters.crmFilter;
        }
    },

    data: () => ({
    }),

    methods: {
        onFilter () {
            this.$store.dispatch("setFilterByUser", this.filter).then(() => {
                this.$emit("filter", this.filter);
            });
        }
    }
}
</script>

<style scoped>

</style>